<template>
  <div class="special">
    <h4 class="module__title">{{ meta.title }}</h4>
    <div class="module__description">{{ meta.description }}</div>
    <div class="hidden md:flex flex-wrap">
      <div v-if="meta.image" class="special__cover__wrap w-full md:w-1/2">
        <div class="special__cover" v-lazy:background-image="`${meta.image}?width=${specialImageWidth*MAGNIFACATION}&format=webp`"></div>
      </div>
      <div class="w-1/2 md:w-1/4 p-8" v-for="(hotel, index) in meta.content" :key="index">
        <hotelCardHome
          :hotel="hotel"
        />
      </div>
    </div>
    <div class="relative block md:hidden">
      <swiper :options="options" :ref="`swiper-${cid}`" class="h-full sm:rounded">
        <swiper-slide v-for="(hotel, index) in meta.content" :key="`hotelswiper-${index}`">
          <hotelCardHome
            :hotel="hotel"
          />
        </swiper-slide>
      </swiper>
      <div class="hidden md:block" :class="`swiper-button-prev swiper-button-prev-${cid}`" slot="button-prev">
        <i class="owl-direction-left"></i>
      </div>
      <div class="hidden md:block" :class="`swiper-button-next swiper-button-next-${cid}`" slot="button-next">
        <i class="owl-direction-right"></i>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import hotelCardHome from './components/hotelCardHome'

export default {
  name: 'module_Special',
  props: ['meta'],
  components: {
    hotelCardHome
  },
  data () {
    return {
      cid: this._uid,
      options: {
        loop: false,
        preventInteractionOnTransition: true,
        slideToClickedSlide: false,
        navigation: {
          nextEl: `.swiper-button-next-${this._uid}`,
          prevEl: `.swiper-button-prev-${this._uid}`
        },
        grabCursor: true,
        breakpoints: {
          3000: {
            slidesPerView: 3,
            slidesPerGroup: 3,
            spaceBetween: 24
          },
          768: {
            slidesPerView: 1.5,
            slidesPerGroup: 1.5,
            spaceBetween: 16
          },
          430: {
            slidesPerView: 1.2,
            slidesPerGroup: 1.2,
            spaceBetween: 16
          }
        },
        pagination: {
          el: '.swiper-pagination'
        }
      },
      MAGNIFACATION: 1.5
    }
  },
  computed: {
    ...mapGetters({
      currencySign: 'user/currencySign',
      selectedCurrency: 'user/selectedCurrency',
      initWidth: 'initWidth'
    }),
    specialImageWidth () {
      if (this.initWidth >= 1200) {
        return 576
      } else if (this.initWidth < 1200 && this.initWidth >= 992) {
        return 472
      } else if (this.initWidth < 992 && this.initWidth >= 768) {
        return 360
      } else {
        return 360
      }
    },
    swiper () {
      return this.$refs[`swiper-${this.cid}`].swiper
    }
  },
  methods: {
    goToHotel: function (hotel) {
      return {
        name: 'HotelDetail',
        params: { hotelId: hotel.hotelUUID },
        query: {
          ...this.$route.query,
          externalId: hotel.hotelUUID,
          searchId: hotel.hotelUUID,
          search: hotel.hotelNameLocal,
          searchType: 'hotel',
          source: hotel.source
        }
      }
    },
    hotelCover: function (hotel) {
      if (hotel.image) {
        return `${hotel.image}?width=1440&format=webp`
      }
      return require('@/assets/images/default-room.jpg')
    }
  }
}
</script>

<style lang="sass" scoped>
.special
  @apply mb-0 py-16
  @screen md
    @apply mb-48 -mx-8 py-0
  &__cover
    @apply w-full
    border-radius: 1.25rem
    padding-top: imageRatio(603, 316)
    background:
      position: center
      repeat: no-repeat
      size: cover
    &__wrap
      @apply p-8
  &__content
    @apply py-8 px-4
  .coverImage
    @apply bg-grey-lightest
    border-radius: 1.25rem
    padding-top: imageRatio(324, 192)
    background:
      position: center
      repeat: no-repeat
      size: cover
</style>
<style lang="sass">
.special
  .swiper-container
    @apply px-16
    @screen sm
      @apply px-0
  .swiper-button-prev, .swiper-button-next
    @apply outline-none #{!important} rounded-full bg-white border border-1 border-grey-light
    padding-top: 4px
    padding-left: 2px
    background-image: none !important
    width: 40px !important
    height: 40px !important
    margin-top: -20px !important
    i[class*=owl-direction]
      @apply text-grey-darkest
      font-size: 24px
  .swiper-button-prev
    left: 0px !important
    @screen sm
      left: -20px !important
  .swiper-button-next
    right: 0px !important
    @screen sm
      right: -20px !important
  .swiper-button-disabled
    @apply hidden
</style>
